import React from "react"
import {
  Modal,
  IModal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalFooter,
  Box,
} from "@chakra-ui/core"
import { FluidObject } from "gatsby-image"

import ModalCloseButton from "../Buttons/ModalCloseButton"
import Slider from "../Slider"
import BackgroundImage from "../BackgroundImage"

type SlideModalProps = Omit<IModal, "children"> & {
  images: FluidObject[]
  initialIndex?: number
}

export default function SliderModal({
  images,
  initialIndex = 0,
  ...props
}: SlideModalProps) {
  return (
    <Modal size="full" isCentered {...props}>
      <ModalOverlay />
      <ModalContent h="100%">
        <ModalCloseButton zIndex={1000} />
        <Slider
          containerProps={{
            h: "100%",
            w: "100%",
          }}
          items={images.map((image, index) => (
            <Box key={index} h="100%" w="100%">
              <BackgroundImage
                fluid={image}
                h="100%"
                w="100%"
                backgroundSize="contain"
                pointerEvents="none"
              />
            </Box>
          ))}
        >
          {({ Slides, Dots }) => (
            <>
              <ModalBody display="flex" w="100%" h="100%">
                {Slides}
              </ModalBody>
              <ModalFooter width="100%">{Dots}</ModalFooter>
            </>
          )}
        </Slider>
      </ModalContent>
    </Modal>
  )
}
